import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqKeys = ["q1", "q2", "q3", "q4", "q5"];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <h2 className="text-center font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("faq.title")}
        </h2>

        <div className="mt-10 space-y-3">
          {faqKeys.map((key, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={key}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {t(`faq.${key}`)}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i
                      className={`${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      } text-sm`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {t(`faq.${key.replace("q", "a")}`)}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}